import { Button, Form, message, Modal, notification } from "antd";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import ModalHeaderText from "../../../common/ModalHeaders/ModalHeaderText";
import TextInput from "../../../common/UITextInput/TextInput";
import UiDropDown from "../../../components/UiDropDown/DropDown";
import useForm from "./../../../common/hooks/useForm";

import verfiedGreenIcon from "../../../images/verfied-green-icon.png";
import verfiedGrayIcon from "../../../images/verfied-gray-icon.png";
import passwordMatchIcon from "../../../images/password-match-icon.png";
import useWindowSize from "../../../utils/useWindowSize";
import { changePassword } from "../../../redux/Auth/authActions";

const ChangePassword = (props) => {
  const [form] = Form.useForm();
  const FormItem = Form.Item;
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);
  const { width } = useWindowSize();
  const mobile = width < 786 ? true : false;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const { state, setState, onChangeTextHandler } = useForm();
  const showModal = () => {
    setIsModalVisible(true);
    form.resetFields();
  };

  const handleChangePassword = () => {
    message.destroy();
    message.loading("Please Wait...", 0);
    props
      .changePassword({
        oldPassword: state.current,
        newPassword: state.password,
      })
      .then((res) => {
        message.destroy();
        if (res && res.status === 200) {
          setIsModalVisible(false);
          form.resetFields();
          setState({
            ...state,
            current: "",
            password: "",
            confirm: "",
          });
          message.success(res?.data?.success?.message);
        }
        if (res?.data?.error?.message || res.message) {
          notification.error({
            description: res?.data?.error?.message || res.message,
            duration: 5,
            placement: "top",
          });
        }
      })
      .catch((err) => {
        message.destroy();
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
    setState({
      ...state,
      current: "",
      password: "",
      confirm: "",
    });
  };

  return (
    <>
      {mobile ? (
        <p
          style={{ cursor: "pointer", color: "#00b1b1" }}
          onClick={() => {
            showModal();
            props.hide && props.hide();
          }}
        >
          CHANGE PASSWORD
        </p>
      ) : (
        <h6 onClick={showModal}>CHANGE PASSWORD | </h6>
      )}

      <Modal
        open={isModalVisible}
        closable={false}
        className="modal-container"
        centered
        footer={null}
      >
        {" "}
        <Form
          autoComplete="off"
          name="changePassword"
          className="change-password"
          form={form}
          onFinish={handleChangePassword}
        >
          <Row>
            <Col lg={12} xs={12} md={12} sm={12}>
              <Col md={12} className="headre-login">
                <ModalHeaderText LoginHeading="Change Password" />
              </Col>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={12}>
              <TextInput
                title="Please Enter Current Password"
                type="password"
                name="current"
                value={state.current}
                dependencies={["password"]}
                hasFeedback
                validation={[
                  {
                    required: true,
                    message: "Please Enter Current Password!",
                  },
                ]}
                placeholder="Enter Current Password"
                onChange={onChangeTextHandler}
              />
            </Col>
          </Row>{" "}
          <Row className="change-password-row">
            <Col md={12} className="password-input-field">
              <TextInput
                title="New Password"
                type="password"
                name="password"
                value={state.password}
                maxLength={20}
                // minLength={8}
                onFocus={() => setIsPasswordFocused(true)}
                onBlur={() => setIsPasswordFocused(false)}
                validation={[
                  {
                    required: true,
                    message: "Passwords cannot be empty",
                  },
                  // mimimum 8 characters, at least one uppercase letter, one lowercase letter, one number and one special character with no white spaces

                  {
                    pattern:
                      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                    message: mobile
                      ? "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number and one special character"
                      : "",
                  },
                  // not include white space
                  {
                    pattern: new RegExp("^(?!.*\\s).*$"),
                    message: "",
                  },
                ]}
                placeholder="Enter Password"
                onChange={onChangeTextHandler}
              />
              {!mobile &&
                (isPasswordFocused ||
                  form
                    .getFieldsError(["password"])
                    .filter(({ errors }) => errors.length).length > 0) && (
                  <div className="error-popup">
                    <div className="error-icon">
                      {new RegExp("^(?!.*\\s).*$").test(state.password) ? (
                        <img
                          src={verfiedGreenIcon}
                          alt="success"
                          className="password-icon"
                        />
                      ) : (
                        <img
                          src={verfiedGrayIcon}
                          alt="error"
                          className="password-icon"
                        />
                      )}

                      <p
                        className={
                          new RegExp("^(?!.*\\s).*$").test(state.password)
                            ? "error-text-green"
                            : "error-text-gray"
                        }
                      >
                        Password must not contain white spaces
                      </p>
                    </div>
                    <div className="error-icon">
                      {state?.password?.length >= 8 ? (
                        <img
                          src={verfiedGreenIcon}
                          alt="success"
                          className="password-icon"
                        />
                      ) : (
                        <img
                          src={verfiedGrayIcon}
                          alt="error"
                          className="password-icon"
                        />
                      )}

                      <p
                        className={
                          state?.password?.length >= 8
                            ? "error-text-green"
                            : "error-text-gray"
                        }
                      >
                        Password must be minimum 8 characters
                      </p>
                    </div>

                    <div className="error-icon">
                      {state?.password?.match(/[a-z]/) ? (
                        <img
                          src={verfiedGreenIcon}
                          alt="success"
                          className="password-icon"
                        />
                      ) : (
                        <img
                          src={verfiedGrayIcon}
                          alt="error"
                          className="password-icon"
                        />
                      )}

                      <p
                        className={
                          state.password?.match(/[a-z]/)
                            ? "error-text-green"
                            : "error-text-gray"
                        }
                      >
                        Atleast one lower case letter
                      </p>
                    </div>
                    <div className="error-icon">
                      {state?.password?.match(/[A-Z]/) ? (
                        <img
                          src={verfiedGreenIcon}
                          alt="success"
                          className="password-icon"
                        />
                      ) : (
                        <img
                          src={verfiedGrayIcon}
                          alt="error"
                          className="password-icon"
                        />
                      )}

                      <p
                        className={
                          state.password?.match(/[A-Z]/)
                            ? "error-text-green"
                            : "error-text-gray"
                        }
                      >
                        Atleast one upper case letter
                      </p>
                    </div>
                    <div className="error-icon">
                      {state.password?.match(/[0-9]/) ? (
                        <img
                          src={verfiedGreenIcon}
                          alt="success"
                          className="password-icon"
                        />
                      ) : (
                        <img
                          src={verfiedGrayIcon}
                          alt="error"
                          className="password-icon"
                        />
                      )}

                      <p
                        className={
                          state.password?.match(/[0-9]/)
                            ? "error-text-green"
                            : "error-text-gray"
                        }
                      >
                        Atleast one number
                      </p>
                    </div>
                    <div className="error-icon">
                      {state.password?.match(/[$@#&!]/) ? (
                        <img
                          src={verfiedGreenIcon}
                          alt="success"
                          className="password-icon"
                        />
                      ) : (
                        <img
                          src={verfiedGrayIcon}
                          alt="error"
                          className="password-icon"
                        />
                      )}

                      <p
                        className={
                          state.password?.match(/[$@#&!]/)
                            ? "error-text-green"
                            : "error-text-gray"
                        }
                      >
                        Atleast one sepcial character
                      </p>
                    </div>
                  </div>
                )}
            </Col>
            <Col md={12}>
              <TextInput
                title="Confirm Password"
                type="password"
                name="confirm"
                value={state.confirm}
                dependencies={["password"]}
                hasFeedback
                validation={[
                  {
                    required: true,
                    message: "Please confirm your password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "The two passwords that you entered do not match!"
                        )
                      );
                    },
                  }),
                ]}
                placeholder="Enter Confirm Password"
                onChange={onChangeTextHandler}
              />
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={12} className="login-btn">
              {state.password &&
                state.confirm &&
                new RegExp("^(?!.*\\s).*$").test(state.password) &&
                state.password.length >= 8 &&
                state.password.match(/[a-z]/) &&
                state.password.match(/[A-Z]/) &&
                state.password.match(/[0-9]/) &&
                state.password.match(/[$@#&!]/) &&
                state.password === state.confirm && (
                  <div className="password-match">
                    <img
                      src={passwordMatchIcon}
                      alt="success"
                      className="password-icon"
                    />
                    <p className="text-green">Password Match!!</p>
                  </div>
                )}
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={12} className="d-flex justify-content-end mt-4">
              <Button
                className="mr-3"
                htmlType="button"
                type="default"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
              <Button
                className=""
                htmlType="submit"
                type="primary"
                // disabled={
                //   !form.isFieldsTouched(true) ||
                //   !!form.getFieldsError().filter(({ errors }) => errors.length)
                //     .length
                // }
              >
                CONFIRM
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    changePassword: (user) => dispatch(changePassword(user)),
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
